<h3 *ngIf="{ optionName: 'rims', key: 'title' } | optionTranslation | async" class="rims__title">
    {{ { optionName: 'rims', key: 'title' } | optionTranslation | async }}
</h3>

<ng-content></ng-content>

<div class="rims__selection">
    <span class="rims__description">{{ selectedDescription || '' }}</span>
</div>
